// extracted by mini-css-extract-plugin
module.exports = {"InformationItem":"InformationItem_InformationItem__vdpWc","Label":"InformationItem_Label__3P03H","Value":"InformationItem_Value__35DFC"};